export const INITIAL_CAMERA_POSITION = [0, 0, 50] as const;
